import axios from 'axios';

/**
 * [cliente env url/api]
 */
export const PbxHttpClient = axios.create({
  baseURL: process.env.VUE_APP_ROOTAPI,
  // timeout: 2000,
  headers: {
    'Access-Control-Allow-Origin': process.env.VUE_APP_ROOTAPI,
  },
});

export const PbxPublicHttpClient = axios.create({
  baseURL: process.env.VUE_APP_ROOTAPI,
  // timeout: 2000,
  headers: {
    'Access-Control-Allow-Origin': process.env.VUE_APP_ROOTAPI,
  },
});
